// The CSP in vercel.json has no 'unsafe-eval'. Zod probes `new Function` when the first object schema
// is defined, so every page load logged a CSP violation before falling back to this same jitless
// parser. Defining a schema happens at module load, so main.tsx imports this module first.
import { config } from "zod";

config({ jitless: true });
